###
  CRUD Sites template
###

class INTENT.templates.CrudSegment

  @get_terms_list: (options, active = null) ->
    options_list = ""

    for ex_type, ex_options of options
      value = ex_type
      label = ex_options.label || value

      unless active
        active_option = false
      else
        active_option = (active == value)

      options_list = options_list + @get_option_element value, label, active_option

    return options_list

  @get_options_list: (list, active = null) ->
    options_list = ""

    # приводим числа к типу number
    if typeof active != typeof String
      active = INTENT.utils.Helper.to_int_object active

    for ex_key, ex_value of list
      # приводим числа к типу number
      if parseInt ex_key
        ex_key = parseInt ex_key

      unless active
        active_option = false
      else
        if typeof active != typeof String
          active_option = (active.indexOf(ex_key) > -1)
        else
          active_option = (active == ex_key)

      options_list = options_list + @get_option_element ex_key, ex_value, active_option

    return options_list

  @get_tokenizator_options_list: (list) ->
    options_list = ""

    for ex_key, ex_value of list
      options_list = options_list + @get_option_element ex_value, ex_value, true

    return options_list

  @get_option_element: (value, label = null, selected = true) ->
    if selected == true then selected = " selected"
    unless label then label = value

    """
    <option value="#{escapeHtml(value)}"#{selected}>#{escapeHtml(label)}</option>
    """

  @get_select_ajax_control: (id, type, select_type, list, active, advertiser_id) =>
    list = @get_options_list list, active
    """
    <select name='terms[#{id}][values][]' data-tags="false" data-ajax--url="/ajax/available_#{select_type}?advertiser=#{advertiser_id}&action=#{type}" class="segments_ajax_select form-control min-w300px select2-ajax-init validate-me" multiple>
      #{list}
    </select>
    """

  @get_select_value_control: (id, list, active) =>
    list = @get_options_list list, active
    """
    <select name='terms[#{id}][values][]' data-escape-html="1" class="form-control min-w300px select2-init validate-me" multiple>
      #{list}
    </select>
    """

  @get_select_tokenizator_value_control: (id, list) ->
    list = @get_tokenizator_options_list list
    """
    <select name='terms[#{id}][values][]' class="form-control min-w300px select2-comma-init validate-me" multiple>
      #{list}
    </select>
    """

  @get_text_value_control: (id, value) ->
    value = value.join ','
    """
    <input type="text" class="form-control min-w300px validate-me" name='terms[#{id}][values]' value='#{value}'>
    """

  @get_values_control: (core, id, type, options, values) ->
    option = options[type] || []

    input_mode = option.input || 'text'
    default_value = option.value || ''
    select_type = option.type || ''

    current_value = values.values || []

    advertiser_id = core.get_advertiser_id();

    if input_mode == 'select'
      list = core.get_variants select_type
      if select_type == 'tokenizator'
        return @get_select_tokenizator_value_control id, current_value
      else
        return @get_select_value_control id, list, current_value
    else if input_mode == 'select_ajax'
      list = core.get_variants select_type
      return @get_select_ajax_control id, type, select_type, list, current_value, advertiser_id
    else
      return @get_text_value_control id, current_value

  @get_term: (core, id, options, values = {type: null}) ->
    for first_type of options
      break

    type = values.type || first_type
    if not options[type]?
      return ''

    negative = values.negative || false
    if negative
      negative_checked = ' checked '

    terms_list = @get_terms_list options, type

    default_values = options[type]['default'] || {days: 1, times: 30}

    times = values.times || default_values.times
    days = values.days || default_values.days

    values_control = @get_values_control core, id, type, options, values

    negative_checkbox = if negative == true || negative == 'true'  then "<input type=\"checkbox\" name='terms[#{id}][negative]' value='true' #{negative_checked} style='display: none' >" else ""

    """
    <tr data-widget-crud-segments-terms-id="#{id}">
        <td class='white-column'>
            #{negative_checkbox}
            <select data-widget-crud-segments-terms-type data-width='resolve' name='terms[#{id}][type]' class="form-control w230px select2-init validate-me">
              #{terms_list}
            </select>
        </td>
        <td data-widget-crud-segments-terms-values>
            #{values_control}
        </td>
        <td class='white-column'>
            <input type="text" class="form-control w70px validate-me numbers-only" name='terms[#{id}][times]' value='#{times}'>
        </td>
        <td class='white-column'>
            <div class="pull-left">
              <input type="text" class="form-control w70px validate-me numbers-only" name='terms[#{id}][days]' value='#{days}'>
            </div>
            <div class="pull-left">
              <a href="javascript:void(0)" class='remove-on-disabled' style="display:block;margin-left:40px;margin-top:8px;" data-widget-crud-segments-terms-remove><i class="glyphicon glyphicon-remove"></i></a>
            </div>
        </td>
    </tr>
    """
